/* eslint-disable */

import React, { useEffect, useState, useMemo } from 'react';
import PageContainer from '../../components/PageContainer/PageContainer';
import {
  fetchMenuRequests,
  selectCountByStatus,
  selectMenuRequests,
  selectPageSize,
  selectRowCount,
  setPageSize,
  selectPage,
  setPage
} from './slice';
import { selectCurrentRestaurant, setCurrentRestaurant } from '../Restaurant/slice';
import { useAppDispatch, useAppSelector } from '../../redux/hooks';
import { Container, ContentHeader, Title, ContentBody, MenuRequestsGrid, MenuRequestCard, MenuCardContent, MenuCardInfo, SearchContainer, PaginationContainer, PaginationInfo, PaginationControls, PageSizeControl } from './MenuLoadRequest.styled';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';

import DashboardSummary, { Item } from '../../components/DashboardSummary/DashboardSummary';
import { Summary } from '../Dashboard/Dashboard.styled';
import { withAuthenticationRequired } from '@auth0/auth0-react';
import { useNavigate } from 'react-router-dom';


const MenuLoadRequest: React.FC = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const menuRequestsServer = useAppSelector(selectMenuRequests);
  const [menuRequests, setMenuRequests] = useState(menuRequestsServer);
  const rowCount = useAppSelector(selectRowCount);
  const pageSize = useAppSelector(selectPageSize);
  const currPage = useAppSelector(selectPage);
  const countByStatus = useAppSelector(selectCountByStatus);
  const currentRestaurant = useAppSelector(selectCurrentRestaurant);
  const [searchQuery, setSearchQuery] = useState('');
  const [open, setOpen] = useState(false);

  useEffect(() => {
    dispatch(fetchMenuRequests(0));
  }, [dispatch])

  useEffect(()=>{
    setMenuRequests(menuRequestsServer);
  },[menuRequestsServer]);

  const filteredMenuRequests = useMemo(() => {
    if (!searchQuery.trim()) {
      return menuRequests;
    }
    const lowerQuery = searchQuery.toLowerCase();
    return menuRequests?.filter(menuRequest =>
      (menuRequest.restaurant?.name?.toLowerCase().includes(lowerQuery) ?? false) ||
      (menuRequest.menuDTO?.name?.toLowerCase().includes(lowerQuery) ?? false) ||
      (menuRequest.restaurant?.city?.toLowerCase().includes(lowerQuery) ?? false) ||
      (menuRequest.restaurant?.state?.toLowerCase().includes(lowerQuery) ?? false) ||
      (menuRequest.status?.toLowerCase().includes(lowerQuery) ?? false)
    ) ?? [];
  }, [menuRequests, searchQuery]);

  const totalPages = Math.ceil(rowCount / pageSize);
  const startIndex = currPage * pageSize + 1;
  const endIndex = Math.min((currPage + 1) * pageSize, rowCount);
  const hasNextPage = currPage < totalPages - 1;
  const hasPreviousPage = currPage > 0;

  const statuses: Item[] = countByStatus?.map((city) => {
    const item: Item = {
                        name: city.name,
                        value: ''+city.count
                      }
      return item;
    })??[]

  const handleCardClick = (menuRequest: any) => {
    dispatch(setCurrentRestaurant(menuRequest.restaurant));
    navigate(`/restaurant/${menuRequest.restaurant.alias}/menu/${menuRequest.menuDTO.menuID}`)
  };

  const handlePageSizeChange = (event: any) => {
    dispatch(setPageSize(event.target.value));
  };

  const handleNextPage = () => {
    if (hasNextPage) {
      dispatch(setPage(currPage + 1));
      dispatch(fetchMenuRequests(currPage + 1));
    }
  };

  const handlePreviousPage = () => {
    if (hasPreviousPage) {
      dispatch(setPage(currPage - 1));
      dispatch(fetchMenuRequests(currPage - 1));
    }
  };
    
  // @ts-ignore
  return (
      <PageContainer title='Menu Load Requests' open={open} setOpen={setOpen}>
        <Container>
          <ContentHeader>
            <Title>Menu Load Requests</Title>
          </ContentHeader>

          <Summary>
            <DashboardSummary items={statuses}/>
          </Summary>

          <SearchContainer>
            <TextField
              label="Search menu requests"
              variant="outlined"
              size="small"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              placeholder="Search by restaurant, menu name, location, or status"
              fullWidth
              sx={{ maxWidth: '400px' }}
            />
          </SearchContainer>

          <ContentBody>
            <MenuRequestsGrid>
              {filteredMenuRequests.map((menuRequest) => (
                <MenuRequestCard key={menuRequest.loadMenuRequestId} onClick={() => handleCardClick(menuRequest)}>
                  <MenuCardContent>
                    <MenuCardInfo>
                      <div>
                        <div>Restaurant: {menuRequest.restaurant?.name}</div>
                        <div>Menu Name: {menuRequest.menuDTO?.name}</div>
                        <div>Location: {menuRequest.restaurant?.city}, {menuRequest.restaurant?.state}</div>
                        <div>Status: {menuRequest.status}</div>
                        <div>Created Date: {menuRequest.created ? new Date(menuRequest.created).toLocaleDateString() : 'N/A'}</div>
                      </div>
                    </MenuCardInfo>
                  </MenuCardContent>
                </MenuRequestCard>
              ))}
            </MenuRequestsGrid>
          </ContentBody>

          {rowCount > 0 && (
            <PaginationContainer>
              <PaginationInfo>
                Showing {rowCount > 0 ? startIndex : 0} to {endIndex} of {rowCount} menu requests
              </PaginationInfo>

              <PaginationControls>
                <Button
                  variant="outlined"
                  size="small"
                  disabled={!hasPreviousPage}
                  onClick={handlePreviousPage}
                >
                  Previous
                </Button>
                <PaginationInfo>
                  Page {currPage + 1} of {totalPages}
                </PaginationInfo>
                <Button
                  variant="outlined"
                  size="small"
                  disabled={!hasNextPage}
                  onClick={handleNextPage}
                >
                  Next
                </Button>
              </PaginationControls>

              <PageSizeControl>
                <FormControl size="small" fullWidth>
                  <InputLabel>Items per page</InputLabel>
                  <Select
                    value={pageSize}
                    onChange={handlePageSizeChange}
                    label="Items per page"
                  >
                    <MenuItem value={10}>10</MenuItem>
                    <MenuItem value={25}>25</MenuItem>
                    <MenuItem value={50}>50</MenuItem>
                    <MenuItem value={100}>100</MenuItem>
                  </Select>
                </FormControl>
              </PageSizeControl>
            </PaginationContainer>
          )}
        </Container>
      </PageContainer>
  )
}

export default withAuthenticationRequired(MenuLoadRequest)
